import { gql } from '__generated__'

export const GetRosterCandidateRecruiterNotes = gql(/* GraphQL */ `
    query GetRosterCandidateNotes($rosterCandidateId: ID!) {
        rosterCandidate(rosterCandidateId: $rosterCandidateId) {
            roster {
                id
                permissions {
                    canView
                    canEdit
                }
            }
            internalRecruiterNote {
                id
                note
                updatedAt
                updatedByUser {
                    id
                    preferredName
                }
                createdByUser {
                    id
                    preferredName
                }
                createdAt
            }
            externalRecruiterNote {
                id
                note
                updatedAt
                updatedByUser {
                    id
                    preferredName
                }
                createdByUser {
                    id
                    preferredName
                }
                createdAt
            }
        }
    }
`)

export const ColumnsByTemplateId = gql(/* GraphQL */ `
    query ColumnsByTemplateId($columnTemplateId: ID!) {
        candidateColumns(columnTemplateId: $columnTemplateId) {
            columnName
            internalName
        }
    }
`)
